import PropTypes from 'prop-types'
import styles from './CardInputForm.module.css'

export default function CardInputForm({ cardData, setCardData, errorTarjetas }) {
  const handleChange = (e) => {
    const { name, value } = e.target
    setCardData((prev) => ({ ...prev, [name]: value }))
  }

  return (
    <>
      <div className="mb-3">
        <label className="form-label">Número de tarjeta</label>
        <input
          type="text"
          className={`form-control ${errorTarjetas.number ? styles.isInvalid : ''}`}
          name="number"
          value={cardData.number}
          onChange={handleChange}
          maxLength="16"
          required
        />
        {errorTarjetas.number && (
          <div className={styles.invalidFeedback}>{errorTarjetas.number}</div>
        )}
      </div>

      <div className="mb-3">
        <label className="form-label">Nombre en la tarjeta</label>
        <input
          type="text"
          className={`form-control ${errorTarjetas.name ? styles.isInvalid : ''}`}
          name="name"
          value={cardData.name}
          onChange={handleChange}
          required
        />
        {errorTarjetas.name && (
          <div className={styles.invalidFeedback}>{errorTarjetas.name}</div>
        )}
      </div>

      <div className="row mb-3">
        <div className="col">
          <label className="form-label">Vencimiento (MM/AA)</label>
          <input
            type="text"
            className={`form-control ${errorTarjetas.expiry ? styles.isInvalid : ''}`}
            name="expiry"
            value={cardData.expiry}
            onChange={handleChange}
            placeholder="MM/AA"
            required
          />
          {errorTarjetas.expiry && (
            <div className={styles.invalidFeedback}>{errorTarjetas.expiry}</div>
          )}
        </div>
        <div className="col">
          <label className="form-label">CVV</label>
          <input
            type="password"
            className={`form-control ${errorTarjetas.cvv ? styles.isInvalid : ''}`}
            name="cvv"
            maxLength="4"
            value={cardData.cvv}
            onChange={handleChange}
            required
          />
          {errorTarjetas.cvv && (
            <div className={styles.invalidFeedback}>{errorTarjetas.cvv}</div>
          )}
        </div>
      </div>
    </>
  )
}

CardInputForm.propTypes = {
  cardData: PropTypes.shape({
    number: PropTypes.string,
    name: PropTypes.string,
    expiry: PropTypes.string,
    cvv: PropTypes.string
  }).isRequired,
  setCardData: PropTypes.func.isRequired,
  errorTarjetas: PropTypes.object.isRequired
}
